<!-- Mobile menu for Ionic -->
<ion-menu menuId="main-menu" side="end" content-id="main-content" *ngIf="isMobile">
  <ion-content>
    <div class="userDetails" *ngIf="LoggedIn">
      <div class="userImage" [routerLink]="['/profile']">
        <img src="assets/images/team/profile.png" />
        <span *ngIf="user" class="tc-light">{{user.firstName}}</span>
        <span *ngIf="!user" class="tc-light"></span>
      </div>
    </div>
    <ul class="menu menu-s2">
      <li class="menu-item"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/home'); $event.preventDefault()">Home</a></li>
      <li class="menu-item" *ngIf="LoggedIn"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/dashboard'); $event.preventDefault()">Dashboard</a></li>
      <li class="menu-item"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/cpas'); $event.preventDefault()">CPAs</a></li>
      <li class="menu-item"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/private-schools'); $event.preventDefault()">Private Schools</a></li>
      <li class="menu-item"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/government'); $event.preventDefault()">Government</a></li>
      <li class="menu-item" *ngIf="!isHome"><a class="menu-link nav-link" href="#" (click)="navigateAndCloseMenu('/contact'); $event.preventDefault()">Contact</a></li>
      <li class="menu-item" *ngIf="isHome"><a class="menu-link nav-link" href="#" (click)="scrollTo('contact'); navigateAndCloseMenu('/home'); $event.preventDefault()">Contact</a></li>
    </ul>
    <button *ngIf="LoggedIn" (click)="logout(); navigateAndCloseMenu('/home')" class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt tc-light">Log Out</button>
    <ul class="menu-btns animated fadeInDown" data-animate="fadeInDown" data-delay=".85"
      style="visibility: visible; animation-delay: 0.85s;" *ngIf="!LoggedIn">
      <li><a href="#" class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt" (click)="navigateAndCloseMenu('/basic-reg'); $event.preventDefault()"><span>Sign Up</span></a></li>
      <li><a href="#" class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt" (click)="navigateAndCloseMenu('/login'); $event.preventDefault()"><span>Log In</span></a></li>
    </ul>
  </ion-content>
</ion-menu>

<!-- Main header always visible -->
<header class="nk-header page-header is-shrink is-dark" id="header">
  <div class="header-main fixed-header" [class.header--scrolled]="isScrolled" #header slot="fixed">
    <div class="header-container container">
      <div class="header-main-row">
        <div class="header-logo">
          <a [routerLink]="['/home']">
            <img src="assets/images/hiddin-logo-5.png" />
          </a>
        </div>
        <div class="header-right">
          <nav class="header-menu justify-content-between" id="example-menu-04" *ngIf="!isMobile">
            <ul class="menu-desktop menu-s2 animated fadeInDown" data-animate="fadeInDown"
              data-delay=".75"
              style="visibility: visible; animation-delay: 0.75s; margin-bottom: 0;">
              <li class="menu-item"><a class="menu-link nav-link" [routerLink]="['/home']">Home</a></li>
              <!-- <li class="menu-item"><a class="menu-link nav-link" (click)="verificationMail()">email</a></li> -->
              <li class="menu-item" *ngIf="LoggedIn"><a class="menu-link nav-link"
                  [routerLink]="['/dashboard']">Dashboard</a></li>
              <li class="menu-item"><a class="menu-link nav-link" [routerLink]="['/cpas']">CPAs</a></li>
              <li class="menu-item"><a class="menu-link nav-link"
                  routerLink="/private-schools">Private Schools</a></li>
              <li class="menu-item"><a class="menu-link nav-link"
                  routerLink="/government">Government</a></li>
              <li class="menu-item"><a class="menu-link nav-link"
                  [routerLink]="['/contact']">Contact</a></li>
            </ul>
            <ul class="menu-btns animated fadeInDown" data-animate="fadeInDown" data-delay=".85"
              style="visibility: visible; animation-delay: 0.85s;" *ngIf="!LoggedIn">
              <li>
                <button [routerLink]="['/basic-reg']"
                  class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt">
                  <span style="color: #ffffff">Sign Up</span></button>
              </li>
              <li>
                <button [routerLink]="['/login']"
                  class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt">
                  <span style="color: #ffffff">Login</span>
                </button>
              </li>
            </ul>
            <div class="userDetails" *ngIf="LoggedIn">
              <span *ngIf="user" class="tc-light">| &nbsp;{{user.firstName}}</span>
              <span *ngIf="!user" class="tc-light">| &nbsp;</span>
              <div class="userImage">
                <img *ngIf="!user || !user.imageUrl" src="assets/images/team/profile.png"
                  [routerLink]="['/profile']" />
                <i class="fa fa-star"
                  *ngIf="showStarIcon(user)"></i>
                <a class="register-btn" (click)="openCompleteRegConfirmation()"
                  *ngIf="showRegisterButton(user)"><i
                    class="fa fa-exclamation-circle"
                    matTooltip="Click Here to complete your registration" matTooltipPosition="below"></i></a>
                <img *ngIf="user && user.imageUrl" src="{{user.imageUrl}}"
                  [routerLink]="['/profile']" />
              </div>
              <button (click)="logout()" class="btn btn-rg btn-auto btn-outline btn-grad on-bg-theme-dark-alt tc-light">Log Out</button>
            </div>
          </nav>
          <div class="header-navbar-overlay"></div>
          <ion-buttons class="header-nav-toggle" *ngIf="isMobile">
            <ion-menu-button menu="main-menu" autoHide="false"></ion-menu-button>
          </ion-buttons>
        </div>
      </div>
    </div>
  </div>
</header>